import { RouterProvider } from 'react-router';
import { router } from '@/app/routes';
import { useEffect } from 'react';
import { ThemeProvider } from '@/lib/theme';

export default function App() {
  useEffect(() => {
    document.title = 'Lunar Grid';
  }, []);

  return (
    <ThemeProvider>
      <RouterProvider router={router} />
    </ThemeProvider>
  );
}